// extracted by mini-css-extract-plugin
export default {"leadingVisual":"IssueTypePickerItemLeadingVisual-module__leadingVisual--Fk2Cc","issueTypeColorIndicator":"IssueTypePickerItemLeadingVisual-module__issueTypeColorIndicator--ivyh6"};